export default __webpack_public_path__ + "static/media/logo-channel.5942af20.png";